// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"3144f5cf","960":"3144f5cf","995":"6dad7ce7"}[chunkId] + ".chunk.css";
};